import { Box, Button, List, ListItemButton, Popover, Stack, Typography } from '@mui/material'
import Link from 'next/link'
import React from 'react'
import { Telegram, Twitter } from '@mui/icons-material'
import { useWallet } from '../../WalletContext'
import { ReactComponent as RightSVG } from '@/assets/imgs/right.svg'
import { ReactComponent as DocsSvg } from '@/assets/imgs/docs.svg'
import { ReactComponent as MediumSvg } from '@/assets/imgs/medium.svg'
export type IPopoverProps = {
  anchorEl: any
  handleClose: () => void
}
const listItems = [
  { name: 'Docs', href: 'https://docs.multibit.exchange/multibit', icon: <DocsSvg /> },
  // { name: 'Docs', href: 'https://docs.multibit.exchange/multibit', icon: <DocsSvg /> },
  { name: 'Telegram', href: 'https://t.me/multibitprotocol', icon: <Telegram /> },
  { name: 'Twitter', href: 'https://twitter.com/Multibit_Bridge', icon: <Twitter /> },
  { name: 'Medium', href: 'https://medium.com/@Multibit_Bridge', icon: <MediumSvg /> },
]
const PopoverProps: React.FC<IPopoverProps> = ({ anchorEl, handleClose }) => {
  const open = Boolean(anchorEl)

  const { disconnect, isConnected } = useWallet()

  return (
    <Popover
      id="disconnect-popover"
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      sx={{
        '& .MuiPopover-paper': {
          mt: 8,
        },
      }}
    >
      <Stack
        direction={'column'}
        py={32}
        width={240}
        sx={{
          background: 'var(--ps-primary_bg)',
          border: '1px solid rgba(191, 255, 11, 0.2)',
        }}
      >
        <Link href={'/account'}>
          <Button
            sx={{
              width: '100%',
              justifyContent: 'space-between',
              px: 20,
              height: 40,
              color: '#fff',
            }}
            onClick={() => {
              handleClose()
            }}
          >
            <Typography fontSize={20} variant="body2">
              Account
            </Typography>
            <RightSVG />
          </Button>
        </Link>
        <Typography mt={8} mb={12} variant="subtitle1" px={20} sx={{ opacity: 0.4 }}>
          View your portfolio of related assets on this chain
        </Typography>

        {isConnected && (
          <Button
            sx={{
              height: 40,
              px: 20,
              color: '#fff',
              background: '#1C1F0C',
              justifyContent: 'flex-start',
            }}
            onClick={() => {
              disconnect()
              handleClose()
            }}
          >
            <Typography fontSize={20} variant="body2">
              Disconnect
            </Typography>
          </Button>
        )}
        <List sx={{ mt: 24 }}>
          <Stack direction={'column'} spacing={12}>
            {listItems.map((item, index) => (
              <ListItemButton
                key={index}
                onClick={() => {
                  handleClose()
                  window.open(item.href)
                }}
                sx={{
                  height: 32,
                  display: 'flex',
                  alignItems: 'center',
                  opacity: 0.4,
                  ':hover': {
                    opacity: 1,
                  },
                }}
              >
                <Box sx={{ width: 32, height: 32, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  {item.icon}
                </Box>

                <Typography fontSize={16} fontWeight={500} lineHeight={'20px'} ml={8}>
                  {item.name}
                </Typography>
              </ListItemButton>
            ))}
          </Stack>
        </List>
      </Stack>
    </Popover>
  )
}

export default PopoverProps
